<div class="modal-header">
  <h5 class="modal-title">{{ config.title }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body auth-error-modal-body">
  <div class="auth-error-display auth-error-modal-display">
    <div class="aed-icon-wrap">
      <fa-icon class="aed-icon" [icon]="config.icon" size="3x"></fa-icon>
    </div>
    <div class="aed-code" [attr.data-text]="config.code">{{ config.code }}</div>
    <p class="text-muted mb-0">{{ config.message }}</p>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark me-auto" (click)="close()">
    Close
  </button>

  <button type="button" class="btn btn-primary text-white" (click)="contactSupport()">
    Contact Support
  </button>
</div>
